/***********
 * 附件材料
 **************/
import LaborDetailTitleValue from "./LaborDetailTitleValue.vue";
export default {
  components: {
    LaborDetailTitleValue
  },
  props: {
    laboratoryItemDetail: {
      type: Object
    },
    moudleName: {
      type: String
    },
    fileList: {
      type: Array
    }
  },
  // data() {
  //   return {
  //     fileList: [],
  //   };
  // },
  // watch: {
  //   laboratoryItemDetail(newval, oldval) {
  //     if (newval) {
  //       this.getLileList(newval.id);
  //     }
  //   },
  // },
  methods: {
    // async getLileList(vr_id) {
    //   const data = await this.$get("/34-getAttachmentPageByParam/union-vr", {
    //     vr_id: vr_id,
    //   });
    //   this.fileList = data.content;
    // },
    hrefdetail(url) {
      window.open(url, "_target");
    }

  }
};